import { isAxiosError } from 'axios';
function isApiAxiosError(error) {
    if (!isAxiosError(error)) {
        return false;
    }
    const { response } = error;
    if (typeof response === 'undefined') {
        return false;
    }
    const { data } = response;
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    return (typeof data.status === 'number' &&
        typeof data.instance === 'string' &&
        ((typeof data.title === 'string' && typeof data.details === 'string') ||
            typeof data.errorCode === 'string' ||
            typeof data.staticCode === 'string'));
}
function getErrorMessage(axiosError) {
    const { config, response } = axiosError;
    const errorCode = response?.data.errorCode ?? response?.data.staticCode;
    return `${config?.method?.toUpperCase()} ${response?.data.instance} [${axiosError.response
        ?.status}] ${errorCode ? `(errorCode: ${errorCode})` : ''}`;
}
export class GlovoApiError extends Error {
    constructor(axiosError) {
        // NOTE: Making this assertion in case the constructor is called without previous validation
        // The default values are not relevant in this case, so we are providing falsy ones
        if (typeof axiosError.response === 'undefined') {
            super('Unknown API error. The AxiosError instance lacked a response object');
            this.status = 0;
            this.instance = '';
        }
        else {
            super(getErrorMessage(axiosError));
            const { data: rawError } = axiosError.response;
            this.status = rawError.status;
            this.instance = rawError.instance;
            if (typeof rawError.title === 'string') {
                this.title = rawError.title;
            }
            if (typeof rawError.detail === 'string') {
                this.detail = rawError.detail;
            }
            if (typeof rawError.errorCode === 'string') {
                this.errorCode = rawError.errorCode;
            }
            if (typeof rawError.requestId === 'string') {
                this.requestId = rawError.requestId;
            }
            if (typeof rawError.meta === 'object') {
                this.meta = rawError.meta;
            }
        }
        this.stack = axiosError.stack;
    }
    static from(error) {
        if (!isApiAxiosError(error)) {
            return error;
        }
        return new GlovoApiError(error);
    }
    toJSON() {
        return {
            message: this.message,
            status: this.status,
            instance: this.instance,
            ...(this.title ? { title: this.title } : {}),
            ...(this.detail ? { detail: this.detail } : {}),
            ...(this.detail ? { detail: this.detail } : {}),
            ...(this.errorCode ? { errorCode: this.errorCode } : {}),
            ...(this.staticCode ? { staticCode: this.staticCode } : {}),
            ...(this.requestId ? { requestId: this.requestId } : {}),
            ...(this.meta ? { meta: this.meta } : {}),
            ...(this.stack ? { stack: this.stack } : {}),
        };
    }
    toString() {
        return `GlovoApiError: ${JSON.stringify(this.toJSON())}`;
    }
}
//# sourceMappingURL=glovo-api-error.js.map